// extracted by mini-css-extract-plugin
module.exports = {"large":"ClosingCta_large__bEVlz"};